import { clsx } from "clsx";
import type React from "react";
import type { FC } from "react";

import { Callout, CalloutIntent } from "widgets";

import style from "@/styles/callout.module.scss";

export interface FormNoteProps {
  children: React.ReactNode;
  tooltip?: string;
}

const FormNote: FC<FormNoteProps> = (props) => {
  return (
    <Callout key={"info"} intent={CalloutIntent.Info} className={clsx(style.formMargin)}>
      {props.children}
    </Callout>
  );
};

export { FormNote };
